/* eslint-disable react/prop-types */
import React, { useState } from "react";
import Navbar from "./NavBar";
// import TicketTab from "./TicketTab";
import SideBar from "./SideBar";

const Layout = ({ children, className }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <div className={`bg-light-gray-400 h-screen flex flex-col ${className}`}>
        <Navbar toggleSidebar={toggleSidebar} />

        {/* <TicketTab /> */}
        <div className="flex flex-1 overflow-hidden">
          <SideBar isOpen={isSidebarOpen} />
          <div className="flex-1 overflow-hidden">
            <div className="h-full px-2 pb-2 lg:px-8 lg:pb-8 overflow-auto">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
